<template>
  <div id="app" class="container-fluid">
    <div class="row">
      <nav class="navbar bg-secondary col-12">
        <h1 class="font-weight-bold text-white">口罩地圖</h1>

        <button class="btn btn-secondary d-flex" @click="openModal('info')">
          <i class="far fa-question-circle text-white"></i>
        </button>
      </nav>
      <div class="col-sm-6 mt-3">
        <div class="form-group d-flex flex-column">
          <button
            class="btn btn-primary"
            :class="{'disabled':!user.userStat}"
            @click="flyToUser"
          >搜尋附近藥局</button>
          <select
            class="form-control mt-2 border border-primary"
            v-model="select.city"
            @change="select.county=''"
          >
            <!-- 如果選一個城市&一個區後, 又直接選下一個城市, 此時county內資料未清空, 會產生錯誤 -->
            <option value>請選擇城市</option>
            <option
              v-for="item in allArea"
              :key="item.CityName"
              :value="item.CityName"
            >{{item.CityName}}</option>
          </select>
          <select
            class="form-control mt-2 border border-primary"
            v-model="select.county"
            v-if="select.city"
            @change="updateMap"
          >
            <option value>請選擇地區</option>
            <!-- v-for內不限定只能裝變數, 也能使用方法(e.g.陣列方法) -->
            <option
              v-for="item in allArea.find((item)=>item.CityName===select.city).AreaList"
              :key="item.AreaName"
              :value="item.AreaName"
            >{{item.AreaName}}</option>
          </select>
        </div>
        <ul
          v-if="stores.length"
          class="result result-pc list-group list-unstyled col-sm-12"
          style="height: 500px; overflow:scroll"
        >
          <li
            class="result-list d-flex p-2 shadow-sm rounded-lg mt-2"
            style="border-left:7px solid #ffc107"
          >
            <div>可點選以下藥局並前往其所在位置</div>
          </li>
          <li
            v-for="(item, index) in stores"
            :key="index"
            class="result-list d-flex p-2 shadow-sm rounded-lg mt-2"
            style="border-left:7px solid #20c997"
            @click.prevent="flyTo(item.geometry.coordinates, item)"
          >
            <div>
              <h3 style="display: inline" class="mr-3">{{item.properties.name}}</h3>
            <button @click="openModal('note',item)" v-if="item.properties.note.length > 2">註</button>
              <p>{{item.properties.address}}</p>
              <p>{{item.properties.phone}}</p>
              <small>最後更新: {{item.properties.updated}}</small>
            </div>
            <div class="d-flex ml-auto align-items-center col-6">
              <!-- 隨數量動態變 -->
              <div
                class="quantity qty-pad col-6 text-center rounded-left d-flex align-items-center"
                :class="item.adultClass"
              >
                <div class="icon">
                  <i class="fas fa-male"></i>
                </div>
                <div>{{item.properties.mask_adult}}</div>
              </div>
              <div
                class="quantity qty-pad col-6 text-center rounded-right d-flex align-items-center border-left border-white"
                :class="item.childClass"
              >
                <div class="icon">
                  <i class="fas fa-child"></i>
                </div>
                <div>{{item.properties.mask_child}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-sm-6 p-3">
        <div id="map" style="height:650px"></div>
      </div>

      <!-- 手機瀏覽時顯示在地圖下方 -->
      <ul
        v-if="stores.length"
        class="result result-mobile list-group list-unstyled col-sm-12"
        style="height: 500px; overflow:scroll"
      >
        <li
          class="result-list d-flex p-2 shadow-sm rounded-lg mt-2"
          style="border-left:7px solid #ffc107"
        >
          <div>可點選以下藥局並前往其所在位置</div>
        </li>
        <li
          v-for="(item, index) in stores"
          :key="index"
          class="result-list d-flex p-2 shadow-sm rounded-lg mt-2"
          style="border-left:7px solid #20c997"
          @click.prevent="flyTo(item.geometry.coordinates, item)"
        >
          <div>
            <h3 style="display: inline" class="mr-3">{{item.properties.name}}</h3>
           <button @click="openModal('note',item)" v-if="item.properties.note.length > 2">註</button>
            <p>{{item.properties.address}}</p>
            <p>{{item.properties.phone}}</p>
            <small>最後更新: {{item.properties.updated}}</small>
          </div>
          <div class="d-flex ml-auto align-items-center col-6">
            <!-- 隨數量動態變 -->
            <div
              class="quantity qty-pad col-6 text-center rounded-left d-flex align-items-center"
              :class="item.adultClass"
            >
              <div class="icon">
                <i class="fas fa-male"></i>
              </div>
              <div>{{item.properties.mask_adult}}</div>
            </div>
            <div
              class="quantity qty-pad col-6 text-center rounded-right d-flex align-items-center border-left border-white"
              :class="item.childClass"
            >
              <div class="icon">
                <i class="fas fa-child"></i>
              </div>
              <div>{{item.properties.mask_child}}</div>
            </div>
          </div>
        </li>
      </ul>

      <!-- 手機瀏覽時顯示在地圖下方 -->
    </div>
    <div class="footer bg-secondary p-1 d-flex align-items-center">
      <div class="footer-info text-white ml-3">
        <span class="mr-1">防疫專線 1922 |</span>
        <a
          class="mr-3 text-white"
          style="text-decoration: none;"
          href="https://github.com/recafox/recafox.github.io.git"
        >
          <i class="fab fa-github text-white"></i> Rita Ho
        </a>
        <a class="text-white mr-3" href="https://icons8.com/icon/97574/search">Icons8</a>
      </div>
    </div>
    <!-- 藥局modal -->
    <div
      class="modal fade"
      id="noteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">藥局備註</h5>
            <button
              type="button"
              class="close btn btn-danger"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">{{note}}</div>
        </div>
      </div>
    </div>

    <!-- 藥局備註modal -->
    <!-- 說明modal -->
    <div
      class="modal fade"
      id="infoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">購買規定 (2020/02/18)</h5>
            <button
              type="button"
              class="close btn btn-danger"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul>
              <li>
                每張健保卡每周可購買
                <strong>2片</strong>口罩
              </li>
              <li>
                身分證字號末碼
                <strong>雙號</strong>者可於每週
                <strong>二、四、六</strong>購買，
                <strong>單</strong>號者可於每週一、三、五購買，週日則不限定身分證字號，開放全民皆可購買。(0為雙號)
              </li>
              <li>兒童口罩僅限12歲以下(民國97年[含]後出生者，不分月、日)兒童健保卡購買，13歲以上健保卡僅能購買成人型口罩。</li>
              <li>每人每次限代持一張健保卡受託依時間規定購買</li>
            </ul>
            <a
              href="https://www.cdc.gov.tw/Bulletin/Detail/wycLegOplsUwGsH6_SPAXg?typeid=9"
            >資料來源：衛生福利部疾病管制署</a>
            <h6>圖示說明</h6>
            <ul class="infoBar">
              <li class="text-dark">
                <i class="fas fa-male"></i> ：成人
              </li>
              <li class="text-dark">
                <i class="fas fa-child"></i> ：兒童
              </li>
              <li class="bg-light rounded">售完</li>
              <li class="bg-warning rounded">存貨小於50</li>
              <li class="bg-primary rounded">存貨充足</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 說明modal -->
  </div>
</template>

<script>
import $ from "jquery";
import L from "leaflet";

/**
 * 口罩api規格                   *地名api規格
 * geometry:                    *{
 *  - coordinates[經, 緯]         CityName:'臺北市',
 *
 * properties:                    Arealist:[{
 *  - address                       AreaName:'中正區'}]
 *  - available              }
 *  - county
 *  - town
 *  - mask_adult
 *  - mask_child
 *  - name
 *  - phone
 *  - update
 */

export default {
  name: "App",
  data: () => ({
    osmMap: {},
    data: [],
    select: {
      city: "",
      county: ""
    },
    allArea: [],
    stores: [],
    user: {
      userStat: false,
      coords: []
    },
    iconConfig: {
      shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    },
    note: ""
  }),
  methods: {
    /*************initialize***************/
    //創建地圖
    createMap() {
      const vm = this;

      vm.osmMap = L.map("map", {
        center: [25.03, 121.55],
        zoom: 15
      });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '<a target="_blank" href="https://www.openstreetmap.org/">© OpenStreetMap 貢獻者</a>',
        maxZoom: 18
      }).addTo(vm.osmMap);
    },

    //取得地名
    getArea() {
      this.$http.get("cityName.json").then(response => {
        //console.log(response.data);
        response.data.forEach(item => {
          let add = item.CityName.split("");
          if (add[0] === "臺") {
            add[0] = "台";
          }
          let str = add.join("");
          item.CityName = str;
        });

        this.allArea = response.data;
      });
    },

    flyToUser() {
      const vm = this;
      if (vm.user.userStat === true) {
        vm.removeMarkers();
        vm.select.city = "";
        vm.select.county = "";
        vm.osmMap.flyTo([vm.user.coords[1], vm.user.coords[0]]);
        const icon = new L.Icon({
          iconUrl: `https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png`,
          ...this.iconConfig
        });

        new L.Marker([this.user.coords[1], this.user.coords[0]], {
          icon: icon
        }).addTo(this.osmMap);
        vm.getNearby();
      } else {
        alert("請開啟位置!");
      }
    },
    //取得附近藥局
    //distanceCal(lat1, lng1, lat2, lng2)
    getNearby() {
      const vm = this;
      let raw = vm.data;
      raw.forEach(item => {
        let num = vm.distanceCal(
          item.geometry.coordinates[1],
          item.geometry.coordinates[0],
          vm.user.coords[1],
          vm.user.coords[0]
        );
        item.distance = num;
      });
      let distArr = raw.filter(item => item.distance < 1);
      //距離依近到遠
      distArr.sort((a, b) => {
        return a.distance - b.distance;
      });
      vm.addColor(distArr);
      vm.stores = distArr;
      vm.stores.forEach(item => {
        vm.setMarker(item, "green");
      });
    },
    //右側搜尋列表的口罩結果加上顏色
    addColor(arr) {
      arr.forEach(item => {
        item.adultClass = {
          "bg-light": false,
          "bg-warning": false,
          "bg-primary": false
        };
        item.childClass = {
          "bg-light": false,
          "bg-warning": false,
          "bg-primary": false
        };
        colorize(item, item.properties.mask_adult, item.properties.mask_child);
      });
      //根據口罩剩餘數量改變顏色
      function colorize(item, qtyA, qtyC) {
        switch (true) {
          case qtyA === 0:
            item.adultClass["bg-light"] = true;
            break;
          case 0 < qtyA && qtyA <= 50:
            item.adultClass["bg-warning"] = true;
            break;
          case qtyA > 50:
            item.adultClass["bg-primary"] = true;
            break;
        }
        switch (true) {
          case qtyC === 0:
            item.childClass["bg-light"] = true;
            break;
          case 0 < qtyC && qtyC <= 50:
            item.childClass["bg-warning"] = true;
            break;
          case qtyC > 50:
            item.childClass["bg-primary"] = true;
            break;
        }
      }
    },

    /*************initialize***************/
    /*************action*******************/
    //打開不同modal
    openModal(modalName, item = null) {
      console.log(`#${modalName}Modal`);
      $(`#${modalName}Modal`).modal("show");
      if (item) {
        if(item.properties.note.length > 2){
        this.note = item.properties.note;}else{
          return;
        }
      }
    },

    setMarker(store, color = "green") {
      const vm = this;
      const icon = new L.Icon({
        iconUrl: `https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
        ...vm.iconConfig
      });

      new L.Marker(
        [store.geometry.coordinates[1], store.geometry.coordinates[0]],
        { icon: icon }
      ).addTo(vm.osmMap)
        .bindPopup(`<strong>${store.properties.name}</strong><br>
        <a href="https://www.google.com.tw/maps/place/${store.properties.address}" target="_blank">${store.properties.address}</a><br>
        <p style='margin-top: 3px'>${store.properties.phone}</p><br>
        <div class="d-flex">
              <div class="rounded-left" >
                <p style='font-size:25px'><i style='margin-right:5px' class="fas fa-male"></i>${store.properties.mask_adult}</p>
              </div>
              <div class="ml-4 rounded-right">
                <p  style='font-size:20px; line-height:39px'><i style='margin-right:5px' class="fas fa-child"></i>${store.properties.mask_child}</link>
              </div>
            </div>
        `);
    },
    //移除地圖上所有標示
    removeMarkers() {
      const vm = this;
      vm.osmMap.eachLayer(layer => {
        if (layer instanceof L.Marker) {
          vm.osmMap.removeLayer(layer);
        }
      });
    },
    //飛到指定藥局, 並打該開藥局popup
    flyTo(coords, store) {
      const vm = this;
      vm.osmMap.flyTo([coords[1], coords[0]]);
      vm.osmMap.eachLayer(layer => {
        if (layer._latlng) {
          if (
            layer._latlng.lat === store.geometry.coordinates[1] &&
            layer._latlng.lng === store.geometry.coordinates[0]
          ) {
            layer.openPopup();
          }
        } else {
          return;
        }
      });

      //手機版型時,點選藥局會自動跳至地圖
      const width = screen.width;

      if (width < 376) {
        $("html, body").animate({ scrollTop: $("#map").offset().top }, 800);
      }
    },
    updateMap() {
      const vm = this;
      vm.removeMarkers();
      vm.getStores();
      vm.stores.forEach(item => {
        vm.setMarker(item, "green");
      });
      //vm.setMarker(vm.stores);
      if (vm.stores.length) {
        vm.flyTo(vm.stores[0].geometry.coordinates, vm.stores[0]);
        //打開第一個搜尋結果的popup
        let layerArr = [];
        vm.osmMap.eachLayer(layer => {
          layerArr.push(layer);
        });
        layerArr[1].openPopup();
      } else {
        return;
      }
    },
    getStores() {
      const vm = this;
      /**
       * 篩選方法:
       * 若是使用者什麼都沒選 -> 顯示全部
       * 若是使用者只選了城市 -> 顯示該城市內全部藥局
       * 若是使用者選到了區域 -> 顯示該城市該區域內的藥局
       */

      let cityFilter = vm.data.filter(item => {
        return item.properties.address.includes(vm.select.city);
      });

      let pharms = cityFilter.filter(item => {
        return item.properties.address.includes(vm.select.county);
      });

      vm.addColor(pharms);

      vm.stores = pharms;
    },
    /**
     * lat1 => 目標經度
     * lng1 => 目標緯度
     * lat2 => 使用者經度
     * lng2 => 使用者緯度
     */
    distanceCal(lng1, lat1, lng2, lat2) {
      return (
        2 *
        6378.137 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin((Math.PI * (lat1 - lat2)) / 360), 2) +
              Math.cos((Math.PI * lat1) / 180) *
                Math.cos((Math.PI * lat2) / 180) *
                Math.pow(Math.sin((Math.PI * (lng1 - lng2)) / 360), 2)
          )
        )
      );
    }
  },

  mounted() {
    this.createMap();
    this.getArea();
    //取得使用者位置
    let getUser = () => {
      return new Promise((resolve, reject) => {
        // return promise
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(pos => {
            let lng = pos.coords.longitude;
            let lat = pos.coords.latitude;
            resolve([lng, lat]);
            this.user.userStat = true;
          });
        } else {
          this.user.userStat = false;
        }
      });
    };
    //先取得資料, 在取得使用者位置
    //取得使用者位置後會需要使用data計算附近藥局, 若是藥局的資料比使用者位置還要晚取得, 會在傳資料時造成時間差而無法計算
    this.$http
      .get(
        "https://raw.githubusercontent.com/kiang/pharmacies/master/json/points.json"
      )
      .then(res => {
        this.data = res.data.features;
      })
      .then(getUser)
      .then(data => {
        this.user.coords = data;
        this.flyToUser();
        this.getNearby();
      });
  }
};
</script>

<style lang = 'scss'>
@import "./assets/all";

.infoBar {
  list-style: none;
  padding: 0px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.infoBar li {
  margin-left: 10px;
  font-size: 18px;
  color: white;
  padding: 0 10px;
}

.result {
  height: 500px;
  overflow: scroll;
  line-height: 16px;
}
.result-list:hover {
  cursor: pointer;
}

.result-list button {
  padding: 0.1rem;
  border: none;
  background-color: #dc3545;
  color: white;
  border-radius: 0.2rem;
}

.result-list button:hover {
  background-color: #7c1f28;
}
.result-list .quantity {
  height: 50%;
  font-size: 25px;
}
.result-list i {
  color: white;
  margin-right: 7px;
}
.result-mobile {
  display: none;
}

.navbar button {
  height: 80%;
  font-size: 25px;
  border: 2px solid white;
}

.footer {
  height: 70px;
}

.footer span {
  font-size: 26px;
}

.footer a {
  font-size: 16px;
}

@media (max-width: 769px) {
  .result .quantity {
    padding: 7px;
    font-size: 16px;
  }
}
@media (max-width: 376px) {
  .infoBar li {
    font-size: 14px;
  }
  .result-pc {
    display: none;
  }
  .result-mobile {
    display: block;
  }

  .result-list .quantity {
    height: 50%;
    font-size: 20px;
  }

  .qty-mobile {
    padding: 7px;
  }
  .footer {
    margin-top: 20px;
  }
  .footer span {
    font-size: 20px;
  }
  .footer a {
    font-size: 16px;
    display: inline-block;
  }
}

.leaflet-popup-content {
  font-family: "Microsoft JhengHei", "微軟正黑體", "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 14px;
}
.leaflet-popup-content strong {
  font-size: 18px;
  font-weight: bolder;
}
</style>

